import React from 'react';
import { Card, CardHeader, CardTitle, CardContent } from '@/components/ui/card';
import { BookOpen, CheckCircle, Clock, AlertTriangle } from 'lucide-react';

const TranslatorOverview = ({ stats, onUpdate }) => {
  const statCards = [
    { 
      title: 'Hangende Aanvrae', 
      value: stats.pending_requests, 
      icon: Clock, 
      color: 'text-amber-600',
      bg: 'bg-amber-50'
    },
    { 
      title: 'Goedgekeurde Boeke', 
      value: stats.approved_requests || 0, 
      icon: CheckCircle, 
      color: 'text-green-600',
      bg: 'bg-green-50'
    },
    { 
      title: 'Toegekende Boeke', 
      value: stats.assigned_books, 
      icon: BookOpen, 
      color: 'text-blue-600',
      bg: 'bg-blue-50'
    },
    { 
      title: 'Voltooid', 
      value: stats.completed_books, 
      icon: CheckCircle, 
      color: 'text-purple-600',
      bg: 'bg-purple-50'
    },
  ];

  return (
    <div className="space-y-6" data-testid="translator-overview">
      <div>
        <h2 className="text-3xl font-bold text-gray-900 mb-2" style={{ fontFamily: 'Space Grotesk, sans-serif' }}>
          Oorsig
        </h2>
        <p className="text-gray-600">Jou vertaler dashboard</p>
      </div>

      {/* Warning for rejections */}
      {stats.rejection_count > 0 && (
        <div className={`p-4 rounded-lg flex items-center gap-3 ${
          stats.rejection_count >= 3 ? 'bg-red-50 border border-red-200' : 'bg-amber-50 border border-amber-200'
        }`}>
          <AlertTriangle className={`h-5 w-5 ${stats.rejection_count >= 3 ? 'text-red-600' : 'text-amber-600'}`} />
          <div>
            <p className={`font-medium ${stats.rejection_count >= 3 ? 'text-red-600' : 'text-amber-600'}`}>
              {stats.rejection_count >= 3 
                ? 'Waarskuwing: Nog een verwerping sal lei tot skorsing!' 
                : `Jy het ${stats.rejection_count} verwerping(s)`}
            </p>
            <p className="text-sm text-gray-600">
              Boeke met 84 of meer foute word verwerp. 4 verwerpings lei tot skorsing.
            </p>
          </div>
        </div>
      )}

      {/* Stats Grid */}
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
        {statCards.map((stat, index) => (
          <Card key={stat.title} className="hover:shadow-lg transition-shadow">
            <CardContent className="p-6">
              <div className="flex items-center justify-between">
                <div>
                  <p className="text-sm text-gray-500 mb-1">{stat.title}</p>
                  <p className="text-3xl font-bold text-gray-900">{stat.value}</p>
                </div>
                <div className={`p-3 rounded-full ${stat.bg}`}>
                  <stat.icon className={`h-6 w-6 ${stat.color}`} />
                </div>
              </div>
            </CardContent>
          </Card>
        ))}
      </div>

      {/* Quick Actions */}
      <Card>
        <CardHeader>
          <CardTitle>Vinnige Aksies</CardTitle>
        </CardHeader>
        <CardContent className="space-y-4">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <a 
              href="/translator/book-requests" 
              className="p-4 border rounded-lg hover:bg-gray-50 transition-colors flex items-center gap-3"
            >
              <BookOpen className="h-5 w-5 text-green-600" />
              <div>
                <p className="font-medium">Vra 'n Boek Aan</p>
                <p className="text-sm text-gray-500">Dien 'n nuwe boek aanvraag in</p>
              </div>
            </a>
            <a 
              href="/translator/current-work" 
              className="p-4 border rounded-lg hover:bg-gray-50 transition-colors flex items-center gap-3"
            >
              <Clock className="h-5 w-5 text-blue-600" />
              <div>
                <p className="font-medium">Huidige Werk</p>
                <p className="text-sm text-gray-500">Sien jou toegekende boeke</p>
              </div>
            </a>
          </div>
        </CardContent>
      </Card>

      {/* Info Card */}
      <Card className="bg-green-50 border-green-200">
        <CardContent className="p-6">
          <h3 className="font-semibold text-green-800 mb-2">Hoe werk die betaling?</h3>
          <ul className="text-sm text-green-700 space-y-1">
            <li>• Kort boeke (&lt;100 bladsye): R150 basis</li>
            <li>• Lang boeke (≥100 bladsye): R300 basis</li>
            <li>• R2.00 word afgetrek vir elke fout gevind deur die proefleser</li>
            <li>• 84+ foute = Boek verwerp (geen betaling)</li>
            <li>• 4 verwerpings = Rekening geskors</li>
          </ul>
        </CardContent>
      </Card>
    </div>
  );
};

export default TranslatorOverview;
